import { render, staticRenderFns } from "./q-dialog.vue?vue&type=template&id=191c5ba2&scoped=true&"
import script from "./q-dialog.vue?vue&type=script&lang=js&"
export * from "./q-dialog.vue?vue&type=script&lang=js&"
import style0 from "./q-dialog.vue?vue&type=style&index=0&id=191c5ba2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191c5ba2",
  null
  
)

export default component.exports